import { useDisplayModeContext } from 'common-providers';
import { useRum } from 'common-rum';
import { PageView, useCommonTracking } from 'common-tracking';
import { getCurrentRouteQueryParams } from 'common-utils';
import { NextRouter, useRouter } from 'next/router';
import { MutableRefObject, useCallback, useEffect, useRef } from 'react';

export function buildTrackingProperties(
  rumSessionId?: string | undefined,
  referrer?: MutableRefObject<string | null>,
  isMobileWeb?: boolean,
): Partial<PageView> {
  return {
    sourceURL: referrer?.current
      ? `${window.location.origin}${referrer.current}`
      : document.referrer,
    rumSessionId,
    utm_source: getCurrentRouteQueryParams('utm_source'),
    utm_medium: getCurrentRouteQueryParams('utm_medium'),
    utm_campaign: getCurrentRouteQueryParams('utm_campaign'),
    device: isMobileWeb ? 'mobile' : 'desktop',
  };
}

export const NextRouterTracking = (props: {
  getAdditionalProperty?: (router: NextRouter) => Partial<PageView>;
}) => {
  const router = useRouter();
  const referrer = useRef<string | null>(null);
  const { trackCommonEvent } = useCommonTracking();
  const rum = useRum();
  const rumSessionId = rum.getSession()?.id;
  const { isMobileWeb } = useDisplayModeContext();

  const trackPageView = useCallback(() => {
    const properties = buildTrackingProperties(
      rumSessionId,
      referrer,
      isMobileWeb,
    );
    const additionalPropertyObj = props.getAdditionalProperty?.(router) || {};
    trackCommonEvent({
      type: 'Page Viewed',
      ...properties,
      ...additionalPropertyObj,
    });
  }, [rumSessionId, isMobileWeb, props, router, trackCommonEvent]);
  //track initial view
  useEffect(() => {
    trackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackCommonEvent]);
  //track page changes
  useEffect(() => {
    const handler = () => {
      trackPageView();
    };
    const handleRouteChangeStart = () => {
      referrer.current = router.asPath;
    };
    router.events.on('routeChangeComplete', handler);
    router.events?.on('routeChangeStart', handleRouteChangeStart);
    return () => {
      router.events.off('routeChangeComplete', handler);
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, [router, trackPageView]);

  return <></>;
};
